import { Box } from "@mui/material";
import React from "react";
import FreightCard from "./FreightCard";

export default function FreightsList() {
  return (
    <Box
      sx={{
        mt: 2,
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        // border: "1px solid gray",
      }}
    >
      <FreightCard />
      <FreightCard />
      <FreightCard />
      <FreightCard />
    </Box>
  );
}
